var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Lottie',{attrs:{"className":"animation","renderer":"canvas","loop":true,"autoplay":true,"animationData":_vm.lottieData},on:{"getLottieInstance":_vm.getLottieInstance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }